import React from 'react'

const CopyTextInput = ({ text, onClick }) => {
    const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(text);
          onClick()
        } catch (error) {
        //   console.error('Falha ao copiar texto para a área de transferência:', error);
        }
      };
    
  return (
    <div >
        <span className='copyText bg-gray-100 p-2 border rounded' onClick={copyToClipboard} style={{ cursor: 'pointer'}}>{text}</span>
    </div>
  )
}

export default CopyTextInput